"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Stats_1 = __importDefault(require("@becrop/components/Toolkit/MetricsBoxPlot/models/evolution/Stats"));
function rankTo100(rawRank) {
    if (rawRank === null) {
        return null;
    }
    const MIN_RANK = 1;
    const MAX_RANK = 6;
    let curatedValue = 0.000000;
    if (rawRank === 1.000000) {
        curatedValue = 1.000001;
    }
    else {
        curatedValue = rawRank;
    }
    const rank100 = (curatedValue - MIN_RANK) * (100 / (MAX_RANK - MIN_RANK));
    return Math.max(0, Math.min(100, rank100));
}
function rankTo100Phch(rawRank) {
    if (rawRank === null) {
        return null;
    }
    const MIN_RANK = 0;
    const MAX_RANK = 100;
    const rank100 = (rawRank - MIN_RANK) * (100 / (MAX_RANK - MIN_RANK));
    return Math.max(0, Math.min(100, rank100));
}
function preCalcValue(rawRank, dimension) {
    if (dimension === 'bio')
        return rankTo100(rawRank);
    if (dimension === 'phch')
        return rankTo100Phch(rawRank);
}
class MetricDensity {
    constructor(raw, clusterSamples, dimension) {
        /**
         * This is the sample values for this metric
         * Not all the samples in the cluster should have a value
         */
        this.values = [];
        this.avg = 0;
        this.max = 0;
        this.min = 0;
        this.percentile025 = 0;
        this.percentile05 = 0;
        this.percentile075 = 0;
        this.samples = [];
        if (!raw) {
            return;
        }
        const samples = JSON.parse(raw.samples);
        const unit = raw.unit;
        const ranks = JSON.parse(raw.ranks);
        const raw_ranks = JSON.parse(raw.raw_ranks);
        this.samples = samples.map((code, i) => {
            return {
                sample: clusterSamples.find((s) => s.code === code),
                rank: ranks[i],
                value: preCalcValue(raw_ranks[i], dimension),
                raw_rank: raw_ranks[i],
                unit: unit,
            };
        });
        this.values = this.samples
            .map((s) => s.value)
            .filter((v) => v !== undefined && v !== null && v >= 0);
        const stats = new Stats_1.default(this.values);
        this.avg = stats.avg();
        this.max = stats.max();
        this.min = stats.min();
        this.percentile025 = stats.quantile(0.25);
        this.percentile05 = stats.quantile(0.5);
        this.percentile075 = stats.quantile(0.75);
    }
}
exports.default = MetricDensity;
